// extracted by mini-css-extract-plugin
export var bodySections = "_ap-8";
export var gray = "_ap-7";
export var green = "_ap-4";
export var iconContainer = "_ap-9";
export var iconWidgetContainer = "_ap-1";
export var phoneIcon = "_ap-2";
export var red = "_ap-5";
export var statusDot = "_ap-3";
export var widgetContainer = "_ap-0";
export var yellow = "_ap-6";